import { useCallback, useState } from 'react';
import type { LayoutChangeEvent } from 'react-native';

export function useChartWidth(defaultWidth = 320) {
  const [width, setWidth] = useState(defaultWidth);

  const onLayout = useCallback((event: LayoutChangeEvent) => {
    const next = event.nativeEvent.layout.width;
    if (next > 0) {
      setWidth(next);
    }
  }, []);

  return { width, onLayout };
}
